import React from 'react';
import { useTranslation } from 'react-i18next';
// Components
import PropTypes from 'prop-types';
import { ContentParagraph } from '../../../../../_lib/components/ContentParagraph';
import { Namespace } from '../../../../../translation/namespace';

const normalizeContent = (value, translationNamespace, t) => {
  if (value === undefined || value === null || value === false) {
    return t(`${translationNamespace}:noContent`);
  }

  if (typeof value === 'string') {
    if (translationNamespace === Namespace.HighestConfidentialLevel) {
      return t(`${translationNamespace}:edit.inputs.son_page_confidentialLevel_highest.options.${value}.text`);
    }
    if (translationNamespace === Namespace.DefaultConfidentialLevel) {
      return t(`${translationNamespace}:edit.inputs.son_page_confidentialLevel_default.options.${value}.text`);
    }
    if (translationNamespace === Namespace.PortalUserRegistrationEnabled) {
      return t(`${translationNamespace}:edit.inputs.son_user_registration_mode.options.${value}`);
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentTask) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentTask.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentTopic) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentTopic.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentTeamroom) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentTeamroom.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentLocation) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentLocation.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentOrgunit) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentOrgunit.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForMembersWithParentProcess) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForMembersWithParentProcess.options.${value}`,
      );
    }
    if (translationNamespace === Namespace.DefaultForNewsletterFrequency) {
      return t(
        // linter always turns it back to that version and splitting the string does not work
        // eslint-disable-next-line max-len
        `${translationNamespace}:edit.inputs.son_page_readRestrictionType_defaultForNewsletterFrequency.options.${value}`,
      );
    }

    return value;
  }
  if (value === true) {
    return t(`${translationNamespace}:settingActive`);
  }
  return null;
};

export default function SingleInputDefault({ value = null, translationNamespace }) {
  const { t } = useTranslation();
  return (
    <div className="single-input-block">
      <ContentParagraph>{normalizeContent(value, translationNamespace, t)}</ContentParagraph>
    </div>
  );
}

SingleInputDefault.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  translationNamespace: PropTypes.string.isRequired,
};
